<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter">
            <el-form-item label="是否分销："> 
                <el-select v-model="searchForm.isSold" clearable>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态："> 
                <el-select v-model="searchForm.cardState" clearable>
                    <el-option v-for="item in cardStateOption" :value="item.code" :key="item.id + item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="运营商名称："> 
                <el-select v-model="searchForm.supplierTypeCode" clearable filterable>
                    <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="通道：">
                <el-input v-model.trim="searchForm.alias" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐组名称："> 
                <el-select v-model="searchForm.basePkgGroup" clearable filterable>
                    <el-option v-for="item in agentPkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model.trim="searchForm.intoNo" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
              <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getAgentCardListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="ICCID号段：" class="ICCIDRange">
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidStart" clearable></el-input>
                </el-col>
                <el-col :span="2" class="separate">-</el-col>
                <el-col :span="11">
                    <el-input v-model.trim="searchForm.iccidEnd" clearable></el-input>
                </el-col>                
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentCardListHandle">搜索查询</el-button>
                <el-button type="success" @click="exportSimInfoHandle">导出Excel</el-button>
                <el-button type="primary" @click="showSimHandle">SIM卡分销</el-button>
                <el-button type="primary" @click="simRecoverybutHandler">SIM卡回收</el-button>
            </el-form-item> 
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column label="ICCID号">
                <template slot-scope="scope">
                    <a href="javascript:void(0);" @click="goToInfoPage(scope.row)">{{ scope.row.iccid }}</a>
                </template> 
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号"></el-table-column>
            <el-table-column prop="virtualNo" label="虚拟号"></el-table-column>
            <el-table-column prop="supplierTypeName" label="运营商名称"></el-table-column>
            <el-table-column prop="alias" label="通道"></el-table-column>
            <el-table-column prop="basePkgGroupName" label="套餐组"></el-table-column>
            <el-table-column label="总流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.flowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="已使用流量(G)">
                <template slot-scope="scope">
                    {{ fluxMtoG(scope.row.usedFlowRate) }}
                </template>
            </el-table-column>
            <el-table-column label="剩余流量(G)">
                <template slot-scope="scope">
                    {{ decrease(fluxMtoG(scope.row.flowRate), fluxMtoG(scope.row.usedFlowRate)) }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="cardTypeName" label="卡片类型" width="100"></el-table-column> -->
            <el-table-column prop="agentPathNames" label="分销商姓名"></el-table-column>
            <el-table-column label="卡状态"  width="100px">
                <template slot-scope="scope">
                    {{ scope.row.cardStateName}}
                </template>
            </el-table-column>
            <el-table-column prop="isSoldName" label="分销状态"></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  title="卡片分销" :visible.sync="simHandleVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="simHandleForm" :model="simHandleForm" :rules="simHandleRules" label-width="120px">
                <el-form-item label="代理商：" prop="agentId">
                    <el-select v-model="simHandleForm.agentId" filterable>
                        <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                    </el-select>  
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="simDistributHandler">确 定</el-button>
            </div>             
        </el-dialog>
    </div>
</template>

<script>
import {getAgentCardList, simDistribut, getCardStateDict, simRecovery ,exportSimInfo} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                isSold: '',
                cardState: '',
                supplierCode: '',
                alias: '',
                basePkgGroup: '',
                agentName: '',
                iccid: '',
                intoNo: '',
                iccidStart: '',
                iccidEnd: '',
                virtualNo:null,
                userPhone:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,
            },            
            simHandleVisibale: false,
            simHandleForm: {
                agentId: ''
            },
            agentPkgGroup: [],
            supplierOption: [],
            agentListOption: [],
            cardStateOption: [],

            simHandleRules: {
                agentId: [{required: true, message: '请选择代理商', trigger: 'change'}]
            } 
        }
    },
    methods: {
        cancel(){
            this.simHandleVisibale = false;    
            this.$refs.simHandleForm.resetFields();  
        },
        getAgentCardListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);          
            getAgentCardList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToInfoPage(row){
            this.$store.commit('menu/setFromPage', 'cardList');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardInfoMenu').click();
        },
        showSimHandle(title){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要分销的ICCID号段');
                return false;
            }else{
                this.simHandleVisibale = true;
                common.getAgentListOptionCom(this, 'agentListOption');
            }            
        },        
        exportSimInfoHandle(){//导出excel文件
            this.$confirm("您确定要导出SIM卡列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                exportSimInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去下载专区下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            })
        },
        simDistributHandler(){
            this.$refs.simHandleForm.validate(valid => {
                if(valid){            
                    var data = {
                        iccidStart: this.searchForm.iccidStart,
                        iccidEnd: this.searchForm.iccidEnd,
                        agentId: this.simHandleForm.agentId
                    }
                    simDistribut(data).then(res => {
                        if(res.data.code == 200){
                            this.$message.success('分销完成');
                            this.simHandleVisibale = false;
                            this.getAgentCardListHandle();
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }
            })
        },
        simRecoverybutHandler(){
            var iccidStart = this.searchForm.iccidStart;
            var iccidEnd = this.searchForm.iccidEnd;
            if(iccidStart == "" || iccidEnd == ""){
                this.$message.error('请输入要回收的ICCID号段');
                return false;
            }
            this.$confirm('确定回收这批卡片吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                var data = {
                    iccidStart,
                    iccidEnd
                }
                simRecovery(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getAgentCardListHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }).catch(()=>{})
        }, 
  
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentCardListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getAgentCardListHandle();
        }  
    },
    created () {
        
        common.getAgentPkgGroupListCom(this, 'agentPkgGroup');
        common.getSupplierOptionCom(this, 'supplierOption');
        getCardStateDict({}).then(res => {
            if(res.data.code == 200){
                this.cardStateOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }    
        })

        this.getAgentCardListHandle();
    }
}
</script>

<style lang="less" scoped>

</style>

